import post from 'src/services';
import { getSDKConfig } from 'utils/config';
import { eventTypeCheck } from './util';

const postBeacon = async (events, type) => {
  if (!events || (Array.isArray(events) && events.length === 0)) return;

  let endpoint;

  const localPlatform = localStorage.getItem('GV_NETWORK_PLATFORM_TYPE');
  const { isBatched, isPriority } = eventTypeCheck(type);
  let platform;

  if (!localPlatform) {
    if (isBatched) {
      platform = events[0]?.context?.Platform;
    } else if (isPriority) {
      platform = events?.context?.Platform;
    }

    if (
      platform?.toLowerCase() === 'mweb' ||
      platform?.toLowerCase() === 'web'
    ) {
      localStorage.setItem('GV_NETWORK_PLATFORM_TYPE', 'WEB');
    }
  }

  const sdkConfig = getSDKConfig();

  if (isBatched) {
    endpoint = sdkConfig?.general?.endpoints?.batched;
  } else if (isPriority) {
    endpoint = sdkConfig?.general?.endpoints?.priority;
  }

  const apiConfig = {
    endpoint,
    //batch_size: isBatched ? events.length : undefined,
    timeout: sdkConfig?.general?.api_timeout,
  };
  return await post(apiConfig, events);
};

export default postBeacon;
